import { ClockIcon } from '@heroicons/react/24/outline';

import { WaitlistAddedIcon } from 'honeydew/icons/Shop';

/**
 * Circular back-in-stock waitlist button shown on sold-out product cards in place of the add-to-cart control.
 *
 * @param {Object} props
 * @param {Function} props.onClick - Click handler; should stop event propagation
 * @param {'default'|'session-active'} [props.variant='default'] - Visual state of the icon
 */
function BackInStockWaitlistIcon({ onClick, variant = 'default' }) {
    const isSessionActive = variant === 'session-active';
    const label = isSessionActive ? 'Manage waitlist' : 'Join the waitlist';

    return (
        <button
            type="button"
            aria-label={label}
            className="flex size-[42px] shrink-0 items-center justify-center rounded-full bg-mango"
            onClick={onClick}
        >
            {isSessionActive ? (
                <WaitlistAddedIcon className="size-[42px]" />
            ) : (
                <ClockIcon className="size-[22px] stroke-[2px] text-black" />
            )}
        </button>
    );
}

export default BackInStockWaitlistIcon;
